import { Box, Text } from '@chakra-ui/react';
import Colors from '../../../config/colors';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface Props {
    title: string;
    name: string;
    description?: string;
    isActive: boolean;
    setCurrentPayment: (payment: string) => void;
    imgURL: string;
}

export default function PaymentListItem({
    isActive,
    setCurrentPayment,
    title,
    name,
    description,
    imgURL,
}: Props) {
    return (
        <Box
            display="flex"
            gap="9px"
            alignItems="center"
            justifyContent="space-between"
            borderColor={isActive ? Colors.lightBlue : `#485765`}
            borderWidth="1px"
            borderRadius="7px"
            onClick={() => setCurrentPayment(name)}>
            <Box display="flex" flexDirection="column" width="100%" padding="10px 20px">
                <Text fontSize="15px" color="#fff">
                    {title}
                </Text>
                <Text fontSize="14px" color={Colors.lightGrey2}>
                    {description}
                </Text>
            </Box>
            <LazyLoadImage
                width="120px"
                effect="blur"
                src={imgURL}
                style={{
                    borderRadius: '0px 7px 7px 0px',
                }}
            />
        </Box>
    );
}
